import { useContext } from "react"
import intl from "react-intl-universal"

import RcmpModalMove from "../../molecules/ModalMove"
import RcmpModalMoveInfo from "../../molecules/ModalMoveInfo"
import RcmpBoardInteractions from "../BoardInteractions"
import RcmpModalAddBoard from "../ModalAddBoard"
import ModalConfirmDelete from "../ModalAddPainelCancel"
import RcmpModalInfo from "../ModalInfo"
import RcmpModalExportBoard from "../../molecules/ModalEportBoard"
import StatesOfModals from "../../../contexts/StatesOfModals"

export default function RcmpModalsBoardChange(props) {
  const {
    fnHandleCancel,
    nCardId,
    aNorms,
    bIsOpen,
    fnHandleUpdateBoardSubmit,
    bIsEdit,
    fnHandleCreateBoard,
    schema,
    aBoardData,
    fnSetABoadData,
    fnSetBDeleteBoardConfirmation,
    fnHandleDeleteBoardSubmit,
    bDeleteBoardConfirmation,
    fnSetBDeleteBoard,
    cNameBoard,
    fnSetBisOpen,
    bDeleteBoard,
    fnHandleDeleteBoardCancel,
    fnHandleDeleteBoard,
    bIsMove,
    oGetPaineis,
    bOpenInteractions,
    fnSetBOpenInteractions,
    oSelectedBoard,
    fnCloseModaMoveBoard,
    panelId,
    fnHandleModalInfo,
    fnSetOBoardDataMove,
    bModalInfo,
    fnSetBModalInfo,
    fnMoveBoardSubmit,
    oCurrentPanel,
    oBoardDataMove,
    bIsOpenDubplicate,
    fnOnCloseDuplicateModal,
    fnHandleConfirmDuplicateBoard,
    bIsOpenModalExport,
    fnOnCloseModalExport,
    oCurrentBoard,
  } = props

  const {
    bIsOpenModalDeleteBoardWarning,
    fnSetBIsOpenModalDeleteBoardWarning,
    oBlocksRes,
  } = useContext(StatesOfModals)

  function fnHandleCloseWarningDeleteModal() {
    fnSetBIsOpenModalDeleteBoardWarning(false)
  }

  return (
    <>
      <RcmpModalAddBoard
        fnHandleCancel={fnHandleCancel}
        id={nCardId}
        aNorms={aNorms}
        bIsOpen={bIsOpen}
        bIsEdit={bIsEdit}
        fnHandleUpdateBoardSubmit={fnHandleUpdateBoardSubmit}
        fnHandleCreateBoard={fnHandleCreateBoard}
        schema={schema}
        aBoardData={aBoardData[0]}
        fnSetABoadData={fnSetABoadData}
      />
      <RcmpModalInfo
        size={"sm"}
        bIsOpen={bIsOpenModalDeleteBoardWarning}
        buttonSaveText={intl.get("close")}
        title={intl.get("board.delete_board")}
        description={intl.get("board.delete_board_with_blocks")}
        oButtonCancelProps={{ style: { display: "none" } }}
        oButtonSaveProps={{ style: { marginLeft: "auto" } }}
        oResponse={oBlocksRes}
        fnHandleCancel={fnHandleCloseWarningDeleteModal}
        fnHandleConfirm={fnHandleCloseWarningDeleteModal}
      />
      <ModalConfirmDelete
        size={"sm"}
        fnOnClose={fnSetBDeleteBoardConfirmation}
        fnHandleDelete={fnHandleDeleteBoardSubmit}
        bOnDelete={bDeleteBoardConfirmation}
        isOpen={bDeleteBoardConfirmation}
        headerText={intl.get("board.delete_board")}
        fnSetBDelete={fnSetBDeleteBoard}
        text={intl.get("board.confirm_delete_board", { board: cNameBoard })}
        setModalIsOpen={fnSetBisOpen}
      />
      <RcmpModalInfo
        size={"sm"}
        bIsOpen={bDeleteBoard}
        buttonCancelText={intl.get("cancel")}
        buttonSaveText={intl.get("continue")}
        title={intl.get("board.delete_board")}
        description={intl.get("confirm_operation")}
        fnHandleCancel={fnHandleDeleteBoardCancel}
        fnHandleConfirm={fnHandleDeleteBoard}
      />
      <RcmpBoardInteractions
        bOpenInteractions={bOpenInteractions}
        fnSetBOpenInteractions={fnSetBOpenInteractions}
        oSelectedBoard={oSelectedBoard}
      />
      <RcmpModalMove
        cTitle={intl.get("board.move_board")}
        bIsOpen={bIsMove}
        bOnClose={fnCloseModaMoveBoard}
        oGetData={oGetPaineis}
        cInfoText={intl.get("modal_move.select_destination")}
        nCurrentId={panelId}
        fnSubmitMove={fnHandleModalInfo}
        fnSubmitMoveData={fnSetOBoardDataMove}
        bCollapse={false}
      />
      <RcmpModalMoveInfo
        cTitle={intl.get("board.move_board")}
        bIsOpen={bModalInfo}
        bOnClose={fnSetBModalInfo}
        fnHandleConfirm={fnMoveBoardSubmit}
        cTextConfirmation={intl.get("board.confirm_move_board", { board: cNameBoard })}
        cCurrentName={oCurrentPanel?.name}
        cMoveName={oBoardDataMove.name}
      />
      <RcmpModalInfo
        size={"sm"}
        bIsOpen={bIsOpenDubplicate}
        buttonCancelText={intl.get("no")}
        buttonSaveText={intl.get("yes")}
        title={intl.get("CardBoard.modal.duplicate_board_header")}
        description={intl.get("CardBoard.modal.duplicate_board_message")}
        fnHandleCancel={fnOnCloseDuplicateModal}
        fnHandleConfirm={fnHandleConfirmDuplicateBoard}
      />
      <RcmpModalExportBoard
        nCurrentId={panelId}
        cTitle={intl.get("board.export_board")}
        bIsOpen={bIsOpenModalExport}
        bOnClose={fnOnCloseModalExport}
        fnHandleConfirm={() => {}}
        cTextConfirmation={intl.get("board.confirm_move_board", { board: cNameBoard })}
        cCurrentName={oCurrentPanel?.name}
        cMoveName={oBoardDataMove.name}
        nCurrentBoardId={oCurrentBoard?.id}
      />
    </>
  )
}
